
const FormatDate = (FullDate) => {

    let SplittedDate = FullDate.split("T");
    let SplittedDateWithoutTime = SplittedDate[0].split('-');


    let Day = SplittedDateWithoutTime[2];
    let Month = SplittedDateWithoutTime[1];
    let Year = SplittedDateWithoutTime[0];

    return Day + "/" + Month + "/" + Year;
}

export default FormatDate;